module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQFJREFUOBFjYBgFjKAgWLhwofTfv3/Zk5KS7hEbJDNnzmRlYmIyZgJpYGRk/PDnz5+W+fPnSxBjwP///0EWT/z3798vsAtAmoCuEP758+cUoGRGenr6R3wGAW1vZ2Zm3pOSkrIX7AKQ4vj4+LcsLCxlQNdMBbqEA5cBs2bNKgHKnQNpBqmBGwDiAMPgMdCQtt+/f09ZtWoVM0gMGQA1JwBd+BXowtUwcRQDQIJAQ64BnTf3w4cPvTBFIBqo2QeoWRaoeTqyOE420J/es2fPrgcpmDNnjjXQgD5siuGBiE0SaEAc0FZtIBZKS0tLB4bPP2zq8IoBbffdtm0bO15FQ1sSACZpZjVjdEu9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_icon_open.png
// module id = 822
// module chunks = 124